module.exports = __webpack_public_path__ + "static/media/WhiteLogo.46e7a9a1.png";